import { call } from 'redux-saga/effects';

import { ApiRequestDescriptor } from './apiRequest.types';
import callAndGetResponse from './callAndGetResponse';
import { CreateRequestResponse } from './request';

export function* executeSagaRequest(
  ACTION: CreateRequestResponse,
  { url, config }: ApiRequestDescriptor,
  meta?: unknown,
): Generator {
  return yield call(callAndGetResponse, ACTION, url, config, meta);
}
